<template>
  <cpheader></cpheader>
  <cpconteudo></cpconteudo>
  <cprodape></cprodape>
</template>

<script>
import Cpheader from './layout/header/header.vue'
import Cpconteudo from './layout/conteudo/conteudo.vue'
import Cprodape from './layout/rodape/footer.vue'

export default {
  data () {
    return {
    
    }
  },
  components:{
    Cpheader, Cpconteudo, Cprodape
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?64e135c1